import axios from '../localAxios';
import { getLogoutURL } from './authURLs';

export async function logout(): Promise<void> {
  const logoutURL = getLogoutURL();
  await axios.post(logoutURL.href);
  return;
}
